module.exports = __webpack_public_path__ + "static/img/荣耀 Magic V3.9311f2b8.png";